import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const MagnetIcon = createIcon({
  displayName: 'MagnetIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M5.062,18.938v0c2.749,2.749 7.206,2.749 9.955,0l5.689,-5.689c0.393,-0.393 0.393,-1.029 0,-1.422l-1.422,-1.422c-0.393,-0.393 -1.029,-0.393 -1.422,0l-5.707,5.707c-1.185,1.185 -3.11,1.177 -4.285,-0.019v0c-1.161,-1.181 -1.152,-3.077 0.019,-4.248l5.707,-5.707c0.393,-0.393 0.393,-1.029 0,-1.422l-1.422,-1.422c-0.393,-0.393 -1.029,-0.393 -1.422,0l-5.69,5.689c-2.749,2.749 -2.749,7.206 0,9.955Z"></path>
        <path d="M18.57,15.38l-2.84,-2.84"></path>
        <path d="M11.46,8.27l-2.84,-2.84"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const Magnet: FC<IconProps> = (props) => {
  return <CustomIcon as={MagnetIcon} {...props} />
}

export default memo(Magnet)
